import React from "react";
import Navbar from "../components/layout/Navbar";
import SectionSpine from "../components/layout/SectionSpine";
import HeroSection from "../components/sections/home/HeroSection";
import HumanMobilitySection from "../components/sections/home/HumanMobilitySection";
import UseCasesSection from "../components/sections/home/UseCasesSection";
import CleanSheetSection from "../components/sections/home/CleanSheetSection";
import ValidationStrip from "../components/sections/home/ValidationStrip";
import VisionBand from "../components/sections/home/VisionBand";
import ContactSection from "../components/sections/home/ContactSection";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-paper">
      <Navbar />
      <SectionSpine />
      <main>
        <HeroSection />
        <HumanMobilitySection />
        <UseCasesSection />
        <CleanSheetSection />
        <ValidationStrip />
        <VisionBand />
        <ContactSection />
      </main>
    </div>
  );
};

export default LandingPage;
